import { useCallback, useEffect, useState } from 'react';
import { api } from '../lib/api.ts';
import { useBill } from '../bill.tsx';
import { useStore } from '../store.tsx';
import type { Sale } from '../lib/types.ts';

/**
 * ผังโต๊ะ
 *
 * ★ ลอกจาก screens/TableScreen.js ★
 *   · กริด 5 คอลัมน์ (ช่องละ 20% ของความกว้าง)
 *   · รูปโต๊ะ 200×140 — table-on = มีบิลเปิดค้างอยู่ · table-off = ว่าง
 *   · ชื่อโต๊ะเป็นข้อความทับกลางรูป
 *   · เรียงตามตัวเลขในชื่อโต๊ะ ไม่ใช่ตามตัวอักษร (A2 มาก่อน A10)
 *   · แตะโต๊ะแล้ว "กระโดดไปหมวดสินค้าแรกทันที" ไม่มีขั้นกลาง
 */
export function TableGrid({ onPicked }: { onPicked: () => void }) {
  const store = useStore();
  const bill = useBill();
  const [openSales, setOpenSales] = useState<Sale[]>([]);

  const load = useCallback(async () => {
    try {
      const result = await api.get<{ sales: Sale[] }>('/sales', {
        branchId: store.branch.id,
        status: 'open',
      });
      setOpenSales(result.sales);
    } catch {
      setOpenSales([]);
    }
  }, [store.branch.id]);

  useEffect(() => { void load(); }, [load]);

  // โต๊ะ "ไม่ว่าง" = มีบิลที่ยังไม่ปิดผูกอยู่ — เหมือนเงื่อนไขเดิมของแอปเก่า
  const occupied = new Set(
    openSales.filter((s) => s.diningTableId !== null).map((s) => s.diningTableId),
  );

  const pick = (tableId: number, tableName: string) => {
    const existing = openSales.find((s) => s.diningTableId === tableId);
    if (existing) {
      // โต๊ะที่มีบิลอยู่แล้ว → เปิดบิลใบนั้นขึ้นมาต่อ ไม่ใช่เปิดใบใหม่ซ้อน
      void bill.loadSale(existing.id).then(() => {
        bill.setPayload({ tableName });
        onPicked();
      });
      return;
    }
    bill.setPayload({
      billType: 'dine_in',
      diningTableId: tableId,
      tableName,
      saleId: null,
      billNo: '',
    });
    onPicked();
  };

  return (
    <div className="table-wrap">
      {store.tables.map((table) => {
        const busy = occupied.has(table.id);
        return (
          <button
            key={table.id}
            className="table-cell"
            onClick={() => pick(table.id, table.name)}
          >
            <img src={busy ? '/ui/table-on.png' : '/ui/table-off.png'} alt="" />
            <span className="tname">โต๊ะ {table.name}</span>
          </button>
        );
      })}
      {store.tables.length === 0 && (
        <div className="grid-empty">สาขานี้ยังไม่ได้ตั้งค่าโต๊ะ</div>
      )}
    </div>
  );
}
